export enum enumEntityByKey {
  IMPORTER = 'importerId',
  CONSIGNEE = 'consigneeId',
  BUYER = 'buyerId',
  SHIP_TO = 'shipToId',
  SELLER = 'sellerId',
  MANUFACTURER = 'manufacturerId',
  CONSOLIDATOR = 'consolidatorId',
  STAFFING_LOCATION = 'stuffingLocationId',
  //TODO: replace after checking working cases
  SHIPMENT = 'shipment',
  HTC = 'htc',
  MF = 'mf',
  RECEIVING_PARTY = 'recipientParty',
  SHIPPING_PARTY = 'shippingParty',
  SHIPMENT_DETAILS = 'shipmentDetails',
}
